<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="table-responsive"
    *ngIf="!hasPendingData && data != null"
>
    <table class="table table-striped table-sm table-bordered-no-cells">
        <thead class="thead-light">
            <tr>
                <th>{{ i18n._53_NAME | translate }}</th>
                <th>{{ i18n._773_PERIOD | translate }}</th>
                <th>{{ i18n._752_SCORE | translate }}</th>
                <th>{{ i18n._774_S_G_RANK | translate }}</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let i of data.items">
                <td>{{ i.name }}</td>
                <!--TODO revise tl-->
                <td>
                    {{ i.startDate | date: 'MMM d' }} -
                    {{ i.endDate | date: 'MMM d' }}
                </td>
                <td>{{ i.score | number: '1.1-1' }}</td>
                <td>{{ i.sgRank }}</td>
                <td class="text-center">
                    <button
                        type="button"
                        class="cmps-btn-table"
                        (click)="showScorecard(i)"
                    >
                        <cmps-icon svgIcon="folder-outline"></cmps-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
